import { render, staticRenderFns } from "./NoticeTable.vue?vue&type=template&id=50811ac4&scoped=true"
import script from "./NoticeTable.vue?vue&type=script&lang=js"
export * from "./NoticeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50811ac4",
  null
  
)

export default component.exports